import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
  },
  {
    path: "",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index"),
        meta: {
          title: "首页",
          icon: "home",
        },
      },
    ],
  },
];

const rechargeOrderList = () => import("@/views/orderManage/rechargeOrderList");

export const asyncRouterMap = [
  {
    path: "/site",
    component: Layout,
    redirect: "/site/list",
    name: "site",
    meta: {
      title: "站点管理",
      icon: "site",
    },
    alwaysShow: true,
    children: [
      {
        path: "list",
        name: "site:list",
        component: () => import("@/views/site/list"),
        meta: {
          title: "站点管理",
        },
      },
    ],
  },
  {
    path: "/orderManage",
    component: Layout,
    redirect: "/orderManage/charge",
    name: "order",
    meta: {
      title: "订单管理",
      icon: "orderManage",
    },
    alwaysShow: true,
    children: [
      {
        path: "all",
        name: "order:all",
        component: rechargeOrderList,
        meta: {
          title: "全部订单",
          rechargeListKind: "all",
        },
      },
      {
        path: "charge",
        name: "order:charge",
        component: rechargeOrderList,
        meta: {
          title: "新能源汽车新能源汽车上门充电",
          rechargeListKind: "charge",
          rechargeOrderType: "1",
        },
      },
      {
        path: "rescue",
        name: "orderManage:rescue",
        component: rechargeOrderList,
        meta: {
          title: "新能源汽车新能源汽车应急救援",
          rechargeListKind: "rescue",
          rechargeOrderType: "2",
        },
      },
      {
        path: "outdoor6",
        name: "order:outdoor6",
        component: rechargeOrderList,
        meta: {
          title: "工地施工临时作业用电",
          rechargeListKind: "plain",
          rechargeOrderType: "6",
        },
      },
      {
        path: "outdoor9",
        name: "order:outdoor9",
        component: rechargeOrderList,
        meta: {
          title: "户外舞台供电服务",
          rechargeListKind: "plain",
          rechargeOrderType: "9",
        },
      },
      {
        path: "outdoor16",
        name: "order:outdoor16",
        component: rechargeOrderList,
        meta: {
          title: "重卡充电",
          rechargeListKind: "withVehicle",
          rechargeOrderType: "16",
        },
      },
      {
        path: "outdoor19",
        name: "order:outdoor19",
        component: rechargeOrderList,
        meta: {
          title: "重卡救援",
          rechargeListKind: "heavyRescue",
          rechargeOrderType: "19",
        },
      },
      {
        path: "outdoor13",
        name: "order:outdoor13",
        component: rechargeOrderList,
        meta: {
          title: "剧组、影视、短剧拍摄供电服务",
          rechargeListKind: "plain",
          rechargeOrderType: "17",
        },
      },
      {
        path: "outdoor14",
        name: "order:outdoor14",
        component: rechargeOrderList,
        meta: {
          title: "服务区移动补电服务",
          rechargeListKind: "withVehicle",
          rechargeOrderType: "18",
        },
      },
      {
        path: "outdoor3",
        name: "order:outdoor3",
        component: rechargeOrderList,
        meta: {
          title: "大型无人机充电服务",
          rechargeListKind: "plain",
          rechargeOrderType: "3",
        },
      },
      {
        path: "outdoor20",
        name: "order:outdoor20",
        component: rechargeOrderList,
        meta: {
          title: "其他场景",
          rechargeListKind: "plain",
          rechargeOrderType: "20",
        },
      },
      {
        path: "outdoor21",
        name: "order:outdoor21",
        component: rechargeOrderList,
        meta: {
          title: "油田施工",
          rechargeListKind: "plain",
          rechargeOrderType: "21",
        },
      },
      {
        path: "outdoor22",
        name: "order:outdoor22",
        component: rechargeOrderList,
        meta: {
          title: "矿区施工",
          rechargeListKind: "plain",
          rechargeOrderType: "22",
        },
      },
      {
        path: "outdoor23",
        name: "order:outdoor23",
        component: rechargeOrderList,
        meta: {
          title: "城市绿化",
          rechargeListKind: "plain",
          rechargeOrderType: "23",
        },
      },
      {
        path: "outdoor24",
        name: "order:outdoor24",
        component: rechargeOrderList,
        meta: {
          title: "政府电力服务",
          rechargeListKind: "plain",
          rechargeOrderType: "24",
        },
      },
      {
        path: "outdoor26",
        name: "order:outdoor26",
        component: rechargeOrderList,
        meta: {
          title: "挖掘机充电",
          rechargeListKind: "plain",
          rechargeOrderType: "26",
        },
      },
      {
        path: "same",
        name: "order:same",
        component: () => import("@/views/orderManage/same"),
        meta: {
          title: "同城配送订单",
        },
      },
    ],
  },
  {
    path: "/mall",
    component: Layout,
    redirect: "/orderManage/charge",
    name: "mall",
    meta: {
      title: "积分商城",
      icon: "orderManage",
    },
    alwaysShow: true,
    children: [
      {
        path: "product",
        name: "mall:product",
        component: () => import("@/views/mall/product"),
        meta: {
          title: "商品管理",
        },
      },
      {
        path: "orderList",
        name: "mall:orderList",
        component: () => import("@/views/mall/orderList"),
        meta: {
          title: "订单管理",
        },
      },
    ],
  },
  {
    path: "/partner",
    component: Layout,
    redirect: "/partner/index",
    name: "partner",
    meta: {
      title: "经销商管理",
      icon: "partner",
    },
    alwaysShow: true,
    children: [
      {
        path: "index",
        name: "partner:index",
        component: () => import("@/views/partner/index"),
        meta: {
          title: "经销商管理",
        },
      },
    ],
  },
  {
    path: "/powerBank",
    component: Layout,
    redirect: "/powerBank/list",
    name: "powerBank",
    meta: {
      title: "充电设备管理",
      icon: "powerBank",
    },
    alwaysShow: true,
    children: [
      {
        path: "list",
        name: "power:bank:list",
        component: () => import("@/views/powerBank/list"),
        meta: {
          title: "充电设备管理",
        },
      },
    ],
  },
  {
    path: "/staff",
    component: Layout,
    redirect: "/staff/list",
    name: "staff",
    meta: {
      title: "送电掌柜管理",
      icon: "staff",
    },
    alwaysShow: true,
    children: [
      {
        path: "list",
        name: "staff:list",
        component: () => import("@/views/staff/list"),
        meta: {
          title: "送电掌柜管理",
        },
      },
    ],
  },
  {
    path: "/userManage",
    component: Layout,
    redirect: "/userManage/list",
    name: "userManage",
    meta: {
      title: "用户管理",
      icon: "userManage",
    },
    alwaysShow: true,
    children: [
      {
        path: "list",
        name: "userManage:list",
        component: () => import("@/views/userManage/list"),
        meta: {
          title: "用户管理",
        },
      },
    ],
  },
  {
    path: "/member",
    component: Layout,
    redirect: "/member/list",
    name: "member",
    meta: {
      title: "会员管理",
      icon: "member",
    },
    alwaysShow: true,
    children: [
      {
        path: "list",
        name: "member:list",
        component: () => import("@/views/member/list"),
        meta: {
          title: "会员套餐",
        },
      },
      {
        path: "info",
        name: "member:info",
        component: () => import("@/views/member/info"),
        meta: {
          title: "会员信息",
        },
      },
    ],
  },
  {
    path: "/finance",
    component: Layout,
    redirect: "/finance/bill",
    name: "finance",
    alwaysShow: true,
    meta: {
      title: "财务管理",
      icon: "site",
    },
    children: [
      {
        path: "bill",
        name: "finance:bill",
        component: () => import("@/views/finance/bill"),
        meta: {
          title: "出入帐管理",
        },
      },
      {
        path: "rebate",
        name: "finance:rebate",
        component: () => import("@/views/finance/rebate"),
        meta: {
          title: "分红管理",
        },
      },
      {
        path: "invoice",
        name: "finance:invoice",
        component: () => import("@/views/finance/invoice"),
        meta: {
          title: "发票管理",
        },
      },
    ],
  },
  {
    path: "/withdrawal",
    component: Layout,
    redirect: "/withdrawal/list",
    name: "withdrawal",
    meta: {
      title: "提现管理",
      icon: "withdrawal",
    },
    alwaysShow: true,
    children: [
      {
        path: "partners",
        name: "withdrawal:partners",
        component: () => import("@/views/withdrawal/partners"),
        meta: {
          title: "经销商提现管理",
        },
      },
      {
        path: "list",
        name: "withdrawal:list",
        component: () => import("@/views/withdrawal/list"),
        meta: {
          title: "掌柜提现管理",
        },
      },
      {
        path: "refund",
        name: "withdrawal:refund",
        component: () => import("@/views/withdrawal/refund"),
        meta: {
          title: "用户退款管理",
        },
      },
    ],
  },
  {
    path: "/vehicle",
    component: Layout,
    redirect: "/vehicle/list",
    name: "vehicle",
    meta: {
      title: "设备管理",
      icon: "vehicle",
    },
    alwaysShow: true,
    children: [
      {
        path: "list",
        name: "vehicle:list",
        component: () => import("@/views/vehicle/list"),
        meta: {
          title: "车辆管理",
        },
      },
      {
        path: "powerBank",
        name: "power:bank:list",
        component: () => import("@/views/powerBank/list"),
        meta: {
          title: "充电设备管理",
        },
      },
    ],
  },
  {
    path: "/admin",
    component: Layout,
    redirect: "/admin/adimnList",
    name: "admin",
    meta: {
      title: "系统管理",
      icon: "product",
    },
    alwaysShow: true,
    children: [
      {
        path: "electricCharge",
        name: "admin:electricCharge",
        component: () => import("@/views/sysManage/electricCharge"),
        meta: {
          title: "电费管理",
        },
      },
      {
        path: "linechart",
        name: "admin:linechart",
        component: () => import("@/views/sysManage/linechart"),
        meta: {
          title: "电价折线图",
        },
      },
      {
        path: "integralList",
        name: "admin:integral:list",
        component: () => import("@/views/sysManage/integralList"),
        meta: {
          title: "积分管理",
        },
      },
      {
        path: "integralRule",
        name: "admin:integral:rule",
        component: () => import("@/views/sysManage/integralRule"),
        meta: {
          title: "积分规则管理",
        },
      },
      {
        path: "invoiceList",
        name: "admin:invoice:list",
        component: () => import("@/views/sysManage/invoiceList"),
        meta: {
          title: "发票管理",
        },
      },
      {
        path: "messageList",
        name: "admin:message:list",
        component: () => import("@/views/sysManage/messageList"),
        meta: {
          title: "平台消息",
        },
      },
      {
        path: "carouselList",
        name: "admin:carousel:list",
        component: () => import("@/views/sysManage/carouselList"),
        meta: {
          title: "轮播图管理",
        },
      },
      {
        path: "feedback",
        name: "admin:feedback:list",
        component: () => import("@/views/sysManage/feedback"),
        meta: {
          title: "意见反馈",
        },
      },
      // {
      //   path: "otherConfig",
      //   name: "admin:other:config",
      //   component: () => import("@/views/sysManage/otherConfig"),
      //   meta: {
      //     title: "其他配置",
      //   },
      // },
      {
        path: "scheduleList",
        name: "admin:schedule:list",
        component: () => import("@/views/schedule/list"),
        meta: {
          title: "定时任务列表",
        },
      },
      {
        path: "scheduleLog",
        name: "admin:schedule:log",
        component: () => import("@/views/schedule/log"),
        meta: {
          title: "定时任务日志",
        },
      },
      {
        path: "scheduleUpdate",
        name: "admin:schedule:update",
        component: () => import("@/views/schedule/updateSchedule"),
        meta: {
          title: "更新定时任务",
        },
        hidden: true,
      },
      {
        path: "adimnList",
        name: "admin:admin",
        component: () => import("@/views/adminUser/list"),
        meta: {
          title: "用户列表",
        },
      },
      {
        path: "adminUpdate",
        name: "admin:admin:update",
        component: () => import("@/views/adminUser/update"),
        meta: {
          title: "更新系统用户",
        },
        hidden: true,
      },
      {
        path: "deptList",
        name: "admin:dept:list",
        component: () => import("@/views/adminUser/dept"),
        meta: {
          title: "部门管理",
        },
        hidden: true,
      },
      {
        path: "adminRole",
        name: "admin:role",
        component: () => import("@/views/role/list"),
        meta: {
          title: "角色列表",
        },
      },
      {
        path: "roleAdd",
        name: "admin:role:add",
        component: () => import("@/views/role/update"),
        meta: {
          title: "更新角色",
        },
        hidden: true,
      },
      {
        path: "adminMenu",
        name: "admin:menu",
        component: () => import("@/views/menu/list"),
        meta: {
          title: "菜单列表",
        },
      },
      {
        path: "menuAdd",
        name: "admin:menu:add",
        component: () => import("@/views/menu/update"),
        meta: {
          title: "更新菜单",
        },
        hidden: true,
      },
      {
        path: "adminConfig",
        name: "admin:config",
        component: () => import("@/views/config/list"),
        meta: {
          title: "配置列表",
        },
      },
      {
        path: "ratioList",
        name: "user:ratio",
        component: () => import("@/views/ratio/list"),
        meta: {
          title: "其他",
        },
      },
      {
        path: "configUpdate",
        name: "admin:config:add",
        component: () => import("@/views/config/update"),
        meta: {
          title: "配置",
        },
        hidden: true,
      },
      // {
      //   path: "adminLog",
      //   name: "admin:log",
      //   component: () => import("@/views/adminLog/list"),
      //   meta: {
      //     title: "系统日志",
      //   },
      // },
      // {
      //   path: "adminLogDetail",
      //   name: "admin:log:detail",
      //   component: () => import("@/views/adminLog/detail"),
      //   meta: {
      //     title: "日志详情",
      //   },
      //   hidden: true,
      // },
      // {
      //   path: "adminDict",
      //   name: "admin:dict",
      //   component: () => import("@/views/dict/list"),
      //   meta: {
      //     title: "字典管理",
      //   },
      // },
      // {
      //   path: "adminDictData",
      //   name: "admin:dict:data",
      //   component: () => import("@/views/dict/data"),
      //   meta: {
      //     title: "字典数据",
      //   },
      //   hidden: true,
      // },
      {
        path: "driverApproval",
        name: "admin:driverApproval",
        component: () => import("@/views/driverApproval/list"),
        meta: {
          title: "审批注册送电掌柜",
        },
      },
    ],
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true,
  },
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: constantRouterMap,
});



// WEBPACK FOOTER //
// ./src/router/index.js